<template>
  <wrld-container :breadcrumbs="this.breadcrumbs" isFluid>
    <AlgoliaSearchWrapper
      indexName="prod_orders"
      urlSync
      :forRoute="$router.currentRoute.name"
    >
      <v-row no-gutters>
        <v-col sm="8">
          <OrderListHeader :search="search"/>
          <AlgoliaCurrentFilters />
          <!-- Results -->
          <ais-configure
            :hitsPerPage="30"
            :filters="selectedDateFilters"
          />
          <ais-state-results>
            <template slot-scope="{ hits }">
              <div v-if="hits.length > 0">
                <ais-hits>
                  <div slot-scope="{ page, items}">
                    <OrderListItem
                      v-for="result in items"
                      :order="result"
                      :key="result.objectID"
                    />
                  </div>
                </ais-hits>
              </div>
              <div v-else>
                <v-col
                  cols="8"
                  class="pr-3"
                >
                  <span class="title font-weight-light">
                    {{ $t('orders.no_result_search') }}
                  </span>
                </v-col>
              </div>
            </template>
          </ais-state-results>

          <!-- Pagination -->
          <AlgoliaPagination />
        </v-col>

        <!-- FILTERS -->
        <v-col
          sm="3"
          offset-sm="1"
          class="filters-panel"
          v-sticky="{ zIndex: 1, stickyTop: 80, disabled: false}"
        >
          <AlgoliaDateFilter
            v-for="(dateFilter, index) in dateFilters"
            :key="index"
            :index="index"
            :dateFilter="dateFilter"
            inSeconds
          />

          <!-- Selectable filters -->
          <AlgoliaSelectableFilters :arrFilters="arrFilters" />

          <!-- numeric filters -->
          <AlgoliaNumericFilters :numFilters="numFilters" />

          <!-- stats -->
          <ais-stats />
        </v-col>
      </v-row>
    </AlgoliaSearchWrapper>
  </wrld-container>
</template>

<script>
import { mapState } from 'vuex'
import axios from '@/plugins/axios-instance.js'
// import algoliasearch from 'algoliasearch/lite'
import OrderListItem from '@/components/orders/OrderListItem'
import OrderListHeader from '@/components/orders/OrderListHeader'
import AlgoliaPagination from '@/components/general/AlgoliaPagination'
import AlgoliaNumericFilters from '@/components/general/AlgoliaNumericFilters'
import AlgoliaSelectableFilters from '@/components/general/AlgoliaSelectableFilters'
import AlgoliaDateFilter from '@/components/general/AlgoliaDateFilter'
import AlgoliaSearchWrapper from '@/components/general/AlgoliaSearchWrapper'
import AlgoliaCurrentFilters from '@/components/general/AlgoliaCurrentFilters'
import { generalHelpers } from '@/_helpers'
// import Sticky from '@/directives/sticky.js'

var ordersURL = 'https://8avugx3xy8.execute-api.eu-west-1.amazonaws.com/prod/orders'

export default {
  name: 'Orders',
  components: {
    OrderListItem,
    OrderListHeader,
    AlgoliaPagination,
    AlgoliaNumericFilters,
    AlgoliaSelectableFilters,
    AlgoliaSearchWrapper,
    AlgoliaDateFilter,
    AlgoliaCurrentFilters
  },
  data () {
    return {
      breadcrumbs: [
        { text: 'Wereldo', disabled: false, href: '#/' },
        { text: this.$i18n.t('orders.orders'), disabled: true }
      ],
      headers: [
        { text: this.$i18n.t('orders.ref'), sortable: false },
        { text: this.$i18n.t('orders.origin'), sortable: false },
        { text: this.$i18n.t('orders.destination'), sortable: false },
        { text: '#' + this.$i18n.t('orders.packages'), align: 'right', sortable: false },
        { text: this.$i18n.t('orders.status'), align: 'center', sortable: false },
        { text: this.$i18n.t('orders.total_weight'), align: 'right', sortable: false },
        { text: this.$i18n.t('orders.total_volume'), align: 'right', sortable: false }
      ],
      search: {
        query: ''
      },
      date_menu: false,
      date_menu2: false,
      departure_date: null,
      delivery_date: null
    }
  },
  computed: {
    ...mapState(['generalApp', 'signedInCompany']),
    selectedDateFilters () {
      return generalHelpers.constructAlgoliaDateFilterString(this.generalApp.algoliaDateFilters)
    },
    dateFilters () {
      return [
        { title: this.$i18n.t('shipments.departure'), attribute: 'pickup.ts' },
        { title: this.$i18n.t('shipments.arrival'), attribute: 'delivery.ts' }
      ]
    },
    arrFilters () {
      return [
        { title: this.$i18n.t('orders.ref_number') + ' - ' + this.$i18n.t('orders.buyer'), attribute: 'buyer.order_ref', hideNumber: false },
        { title: this.$i18n.t('orders.ref_number') + ' - ' + this.$i18n.t('orders.seller'), attribute: 'seller.order_ref', hideNumber: false },
        { title: this.$i18n.tc('companies.companies', 2) + ' - ' + this.$i18n.t('orders.buyer'), attribute: 'buyer.name' },
        { title: this.$i18n.tc('companies.companies', 2) + ' - ' + this.$i18n.t('orders.seller'), attribute: 'seller.name' },
        { title: this.$i18n.t('locations.address') + ' - ' + this.$i18n.t('orders.origin'), attribute: 'pickup.address' },
        { title: this.$i18n.t('locations.address') + ' - ' + this.$i18n.t('orders.destination'), attribute: 'delivery.address' },
        { title: this.$i18n.t('orders.status'), attribute: 'status', i18nPreffix: 'orders.' }
      ]
    },
    numFilters () {
      return [
        { title: this.$i18n.t('orders.weight'), attribute: 'weight' },
        { title: this.$i18n.t('orders.volume'), attribute: 'volume' }
      ]
    }
  },
  methods: {
    toValue (value, range) {
      return [
        value.min !== null ? value.min : range.min,
        value.max !== null ? value.max : range.max
      ]
    },
    getUrl (params) {
      let result = `${ordersURL}/interval?from=${params.from}&to=${params.to}`
      if (params.next !== undefined) {
        return `${result}&token=${params.next}`
      }
      return result
    },
    download (orders, params) {
      axios
        .get(this.getUrl(params))
        .then(resp => {
          orders = orders.concat(resp.data.orders.filter(order => order.locked))

          if (resp.data.next !== undefined) {
            params.next = resp.data.next
          } else {
            // TODO: generate csv

            let formatedOrders = orders.map(order => {
              let importExport = 'import'
              if (this.formatedLocation(order.origin_id) === this.signedInCompany.name) {
                importExport = 'export'
              }

              let org = this.formatedAddress(order.origin_id)
              let dst = this.formatedAddress(order.destination_id)

              let buyetLocationID = order.origin_id
              if (importExport === 'export') {
                buyetLocationID = order.destination_id
              }

              let customer = this.locations.data[buyetLocationID]

              let reason = order.reason
              if (reason === '') {
                reason = 'Požadavek zákazníka'
              }

              return [
                order.departure_date,
                importExport,
                org,
                dst,
                `${customer.company}-${customer.company_ref}`,
                this.signedInCompany.name,
                reason,
                order.comment

              ]
            })

            formatedOrders = [[
              'datum nakládky',
              'export/import',
              'místo nakládky',
              'místo vykládky',
              'zákazník (číslo)',
              'plátce dopravy',
              'duvod',
              'poznámka'
            ]].concat(formatedOrders)

            this.generateCSV(formatedOrders)

            return
          }
          // TODO: filter data created by user
          this.download(orders, params)
        })
        .catch(error => {
          console.log(error)
          // TODO: show some error message
        })
    },
    generateCSV (orders) {
      // let rows = [['name1', 'city1', 'some other info'], ['name2', 'city2', 'more info']]
      let csvContent = 'data:text/csv;charset=utf-8,' + orders.map(e => e.join(';')).join('\r\n')
      var encodedUri = encodeURI(csvContent)
      window.open(encodedUri)
    },
    getLocationByID (locationID) {
      return this.locations.data[locationID]
    },
    formatedLocation (locID) {
      let loc = this.getLocationByID(locID)
      if (loc === undefined) {
        return this.signedInCompany.name // TODO: signed in company or something else?
      }
      return `${loc.company}, ${loc.company_ref}`
    },
    formatedAddress (locID) {
      let loc = this.getLocationByID(locID)
      if (loc === undefined) {
        return 'Undefined' // TODO: undefined or something else?
      }
      return `${loc.address.city} ${loc.address.country}`
    }
  }
}
</script>

<style lang="scss" scoped>
  .filters-panel {
    margin-top: 50px;
  }
  .filters-panel::-webkit-scrollbar {
    width: 0 !important
  }

</style>
